/*
  MH · Apparition des sections au défilement (opacité + léger glissement vers le haut, une seule fois).
  Chargé par snippets/mh-tokens.liquid si le réglage « Apparition des sections au défilement » est coché,
  jamais dans l'éditeur. Seules les sections sous l'écran au chargement sont masquées : le haut de page
  s'affiche tout de suite (pas de retard d'affichage), et sans ce script rien n'est masqué.
  Exclues : le header, et la fiche produit (sa barre d'achat est fixe : un transform la déplacerait).
  Les cartes d'une section apparaissent ensuite l'une après l'autre, dans l'ordre de la page (70ms d'écart,
  les 7e et suivantes en même temps).
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const CARDS = [
    '.mh-product-slider__item', '.mh-product-grid__item', '.mh-collection__item', '.mh-card-category',
    '.mh-reviews__item', '.mh-stories__item', '.mh-card-value', '.mh-card-reassurance', '.mh-figures__item',
    '.mh-faq__item', '.mh-cta__card',
  ].join(', ');
  const STEP = 70;
  const MAX_STEPS = 6;
  const SECTION_DURATION = 600;
  const CARD_DURATION = 500;

  const sections = [...document.querySelectorAll('.mh-section:not(.mh-header):not(.mh-product)')]
    .filter((section) => section.getBoundingClientRect().top > window.innerHeight);
  if (!sections.length) return;

  // Cartes de la section (sans les cartes imbriquées dans une autre carte), dans l'ordre de la page
  const prepareCards = (section) => {
    const cards = [...section.querySelectorAll(CARDS)].filter((card) => !card.parentElement.closest(CARDS));
    let longest = 0;
    cards.forEach((card, position) => {
      const index = Math.min(position, MAX_STEPS);
      card.style.setProperty('--mh-reveal-delay', `${index * STEP}ms`);
      card.classList.add('mh-reveal-item');
      longest = Math.max(longest, index * STEP);
    });
    return { cards, duration: Math.max(SECTION_DURATION, longest + CARD_DURATION) };
  };

  // Une fois tout apparu, la section et ses cartes retrouvent leurs styles d'origine
  const cleanUp = (section, cards) => {
    section.classList.remove('mh-reveal', 'is-revealed');
    cards.forEach((card) => {
      card.classList.remove('mh-reveal-item');
      card.style.removeProperty('--mh-reveal-delay');
    });
  };

  const prepared = new Map();

  // La section apparaît quand son haut atteint 85 % de la hauteur de l'écran
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const section = entry.target;
      const { cards, duration } = prepared.get(section);
      observer.unobserve(section);
      section.classList.add('is-revealed');
      setTimeout(() => cleanUp(section, cards), duration + 100);
    });
  }, { rootMargin: '0px 0px -15% 0px' });

  sections.forEach((section) => {
    prepared.set(section, prepareCards(section));
    section.classList.add('mh-reveal');
    observer.observe(section);
  });
})();
